import { formatMoney } from "Helpers/helpFunction";
import useA from "hook/useA";
import { useSelector } from "react-redux";
import InformationChart from "./InformationChart";

import './RightGrowth.scss'

export default function RightGrowth() {
  const StocksAnalysisStore = useSelector((state: any) => state?.StocksAnalysisStore)
  const AStore = useSelector((state: any) => state?.AStore)
  const { compareDataGrowthOverview, valueMathZero } = useA();
  const data: any = compareDataGrowthOverview(AStore?.GrowthOverview)

  const leftValue = [
    {
      title: 'Tăng trưởng doanh thu thuần',
      color: '#2ad03d',
      chartStart: {
        valueShow: `${formatMoney(data?.netsale_value?.[0], 2)}%`,
        value: data?.net_profit?.[0],
        color: valueMathZero(data?.netsale_value?.[0])
      },
      chartEnd: {
        valueShow: `${formatMoney(data?.netsale_value?.[1], 2)}%`,
        value: data?.net_profit?.[1],
        color: valueMathZero(data?.netsale_value?.[1])
      }
    },
    {
      title: 'Tăng trưởng lợi nhuận thuần',
      color: '#a89cf7',
      chartStart: {
        valueShow: `${formatMoney(data?.net_profit_value?.[0], 2)}%`,
        value: data?.netsale?.[0],
        color: valueMathZero(data?.net_profit_value?.[0])
      },
      chartEnd: {
        valueShow: `${formatMoney(data?.net_profit_value?.[1], 2)}%`,
        value: data?.netsale?.[1],
        color: valueMathZero(data?.net_profit_value?.[1])
      }
    },
    {
      title: 'Tăng trưởng vốn chủ sở hữu',
      color: '#e09137',
      chartStart: {
        valueShow: `${formatMoney(data?.equity_value?.[0], 2)}%`,
        value: data?.equity?.[0],
        color: valueMathZero(data?.equity_value?.[0])
      },
      chartEnd: {
        valueShow: `${formatMoney(data?.equity_value?.[1], 2)}%`,
        value: data?.equity?.[1],
        color: valueMathZero(data?.equity_value?.[1])
      }
    },
  ]


  const totalAssetsGrowth = AStore?.Overview?.totalAssetsGrowth ? formatMoney(AStore?.Overview?.totalAssetsGrowth, 2) : 0
  const paidInCapitalGrowth = AStore?.Overview?.paidInCapitalGrowth ? formatMoney(AStore?.Overview?.paidInCapitalGrowth, 2) : 0

  const dataInformation: any = [
    {
      title: 'Tăng trưởng lợi nhuận gộp',
      value: `${data?.gross_profit ? data?.gross_profit.toFixed(2) : 0}%`,
      color: data?.profit_before_tax ? (data?.profit_before_tax > 0 ? '#2ad03d' : '#e31e4d') : '#ffffff'
    },
    {
      title: 'Tăng trưởng lợi nhuận trước thuế',
      value: `${data?.profit_before_tax ? data?.profit_before_tax.toFixed(2) : 0}%`,
      color: data?.profit_before_tax ? (data?.profit_before_tax > 0 ? '#2ad03d' : '#e31e4d') : '#ffffff'
    },
    { title: 'Tăng trưởng tổng tài sản', value: `${totalAssetsGrowth}%`, color: valueMathZero(totalAssetsGrowth) },
    { title: 'Tăng trưởng vốn điều lệ', value: `${paidInCapitalGrowth}%`, color: valueMathZero(paidInCapitalGrowth) },
  ]

  return (
    <>
      <div className="cdzBqBpmjT">
        <div className="zogazikmll">
          <div className="jvxubtggtj">So sánh với ngành</div>
          <table className="fidxwazhza" style={{ width: '100%' }}>
            <tr>
              <td></td>
              <td className="gyrqabmpdl jzdjlkdwhr">{StocksAnalysisStore?.inputSearch}</td>
              <td className="gyrqabmpdl jzdjlkdwhr">Ngành</td>
            </tr>
            {
              leftValue.map((item, key) => {

                return (
                  <tr key={key}>
                    <td className="" style={{ color: "#ffffff" }}>{item.title}</td>
                    <td className="gyrqabmpdl jzdjlkdwhr" style={{ color: item?.chartStart.color }}>{item?.chartStart?.valueShow}</td>
                    <td className="gyrqabmpdl jzdjlkdwhr" style={{ color: item?.chartEnd.color }}>{item?.chartEnd?.valueShow}</td>
                  </tr>
                )
              })
            }
          </table>
        </div>
        <div className="yeorpwtoqe">
          <div className="jvxubtggtj">Tỷ lệ tăng trưởng</div>
          {/* <InformationChart data={dataInformation} title='Tỷ lệ tăng trưởng' /> */}
          <table className="fidxwazhza" style={{ width: '100%' }}>
            {
              dataInformation.map((item: any, key: number) => {

                return (
                  <tr key={key}>
                    <td className="">{item.title}</td>
                    <td className="gyrqabmpdl jzdjlkdwhr" style={{ color: item?.color }}>{item?.value}</td>
                  </tr>
                )
              })
            }
          </table>
        </div>
      </div>

    </>
  )
}